module.exports = __webpack_public_path__ + "media/images/grey_logos/working-mother-30a59f4d3936ea89839c177be6244ff1.svg";